export default __webpack_public_path__ + "alberta-prescription.ee98ba702dff83e80cee.svg";